<div class="dashboard-content" style="padding: 120px 40px 50px">

  <div class="luqta-header">
    <div class="page-heading">
      <div class="back" (click)="navigateBack()">
        <i class="fa-solid fa-angle-left"></i>
      </div>
      <h3>
        {{ isEditMode ? ('add-content.edit-contest' | translate) : ('add-content.add-contest' | translate) }}
      </h3>

    </div>

    <a (click)="navigateBack()">
      <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="47" height="47" rx="23.5" fill="#FB2A2D" />
        <mask id="mask0_40000187_6913" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="9" y="9" width="29"
          height="29">
          <rect x="9.39844" y="9.40039" width="28.2" height="28.2" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_40000187_6913)">
          <path
            d="M19.2684 28.9685L23.4984 24.7385L27.7284 28.9685L28.9666 27.7304L24.7366 23.5004L28.9666 19.2704L27.7284 18.0322L23.4984 22.2622L19.2684 18.0322L18.0303 19.2704L22.2603 23.5004L18.0303 27.7304L19.2684 28.9685ZM23.5005 34.6629C21.9565 34.6629 20.5053 34.3699 19.1468 33.784C17.7883 33.1981 16.6067 32.4029 15.6019 31.3984C14.597 30.394 13.8015 29.2129 13.2151 27.8549C12.629 26.497 12.3359 25.0462 12.3359 23.5024C12.3359 21.9585 12.6289 20.5073 13.2148 19.1488C13.8008 17.7903 14.596 16.6086 15.6004 15.6038C16.6048 14.599 17.786 13.8034 19.1439 13.2171C20.5018 12.631 21.9526 12.3379 23.4964 12.3379C25.0403 12.3379 26.4916 12.6309 27.8501 13.2168C29.2085 13.8027 30.3902 14.5979 31.395 15.6023C32.3998 16.6068 33.1954 17.7879 33.7817 19.1458C34.3679 20.5037 34.6609 21.9546 34.6609 23.4983C34.6609 25.0423 34.368 26.4935 33.782 27.852C33.1961 29.2105 32.4009 30.3922 31.3965 31.397C30.3921 32.4018 29.2109 33.1974 27.853 33.7837C26.4951 34.3698 25.0442 34.6629 23.5005 34.6629ZM23.4984 32.9004C26.1226 32.9004 28.3453 31.9898 30.1666 30.1685C31.9878 28.3473 32.8984 26.1246 32.8984 23.5004C32.8984 20.8762 31.9878 18.6535 30.1666 16.8323C28.3453 15.011 26.1226 14.1004 23.4984 14.1004C20.8743 14.1004 18.6516 15.011 16.8303 16.8323C15.0091 18.6535 14.0984 20.8762 14.0984 23.5004C14.0984 26.1246 15.0091 28.3473 16.8303 30.1685C18.6516 31.9898 20.8743 32.9004 23.4984 32.9004Z"
            fill="white" />
        </g>
      </svg>
    </a>
  </div>

  <div class="luqta-create-contest-layout">
    <form [formGroup]="addContentForm">
      <!-- Stepper Header -->
      <div class="stepper-wrapper">
        <div class="stepper-items">

          <!-- Step 1 -->
          <div class="stepper-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-indicator">
              <div class="step-circle-outer" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                <div class="step-circle-inner">
                  <i *ngIf="currentStep > 1" class="fa-solid fa-check"></i>
                </div>
              </div>
              <div class="step-text">
                <span class="step-label">{{ 'add-content.step-01' | translate }}</span>
                <span class="step-title">{{ 'add-content.step1-title' | translate }}</span>
                <span class="step-status" [class.completed]="currentStep > 1">
                  {{ currentStep > 1 ? ('add-content.completed' | translate) : ('add-content.pending' | translate) }}
                </span>
              </div>
            </div>
          </div>
          <div class="step-line" [class.completed]="currentStep > 1"></div>

          <!-- Step 2 -->
          <div class="stepper-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-indicator">
              <div class="step-circle-outer" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                <div class="step-circle-inner">
                  <i *ngIf="currentStep > 2" class="fa-solid fa-check"></i>
                </div>
              </div>
              <div class="step-text">
                <span class="step-label">{{ 'add-content.step-02' | translate }}</span>
                <span class="step-title">{{ 'add-content.step2-title' | translate }}</span>
                <span class="step-status" [class.completed]="currentStep > 2">
                  {{ currentStep > 2 ? ('add-content.completed' | translate) : ('add-content.pending' | translate) }}
                </span>
              </div>
            </div>
          </div>
          <div class="step-line" [class.completed]="currentStep > 2"></div>

          <!-- Step 3 -->
          <div class="stepper-item" [class.active]="currentStep === 3">
            <div class="step-indicator">
              <div class="step-circle-outer" [class.active]="currentStep === 3">
                <div class="step-circle-inner">
                  <i *ngIf="currentStep > 3" class="fa-solid fa-check"></i>
                </div>
              </div>
              <div class="step-text">
                <span class="step-label">{{ 'add-content.step-03' | translate }}</span>
                <span class="step-title">{{ 'add-content.step3-title' | translate }}</span>
                <span class="step-status">{{ 'add-content.pending' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8">
          <!-- Step 1: Fill Contest Information -->
          <div *ngIf="currentStep === 1">
            <div class="upload-logo-card" [class.has-preview]="bannerPreviews.length > 0"
              (click)="triggerProfileFileInput()">
              <ng-container *ngIf="bannerPreviews.length > 0; else bannerUploadPlaceholder">
                <div class="banner-preview-container">
                  <div class="banner-slider-track"
                    [style.transform]="'translateX(-' + (activeBannerIndex * 100) + '%)'">
                    <img *ngFor="let img of bannerPreviews" [src]="img" alt="Engagement Banner"
                      class="banner-preview-img" />
                  </div>
                  <div class="banner-preview-overlay">
                    <i class="fa-solid fa-camera"></i>
                    <span>{{ 'add-content.add-more' | translate }}</span>
                  </div>
                  <button class="img-preview-btn" (click)="openImagePreview(bannerPreviews[activeBannerIndex], 'Engagement Banner', $event)" title="Full Preview">
                    <i class="fa-solid fa-expand"></i>
                  </button>
                  <button *ngIf="hasAiAccess" class="img-preview-btn ai-regen-btn" (click)="openAiRegenModal($event)" title="Regenerate with AI">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                  </button>
                  <button *ngIf="activeBannerIndex > 0" class="banner-nav banner-nav-prev" (click)="prevBanner($event)">
                    <i class="fa-solid fa-chevron-left"></i>
                  </button>
                  <button *ngIf="activeBannerIndex < bannerPreviews.length - 1" class="banner-nav banner-nav-next"
                    (click)="nextBanner($event)">
                    <i class="fa-solid fa-chevron-right"></i>
                  </button>
                  <div class="banner-dots" *ngIf="bannerPreviews.length > 1">
                    <span *ngFor="let img of bannerPreviews; let i = index" class="dot"
                      [class.active]="i === activeBannerIndex" (click)="goToBanner(i, $event)"></span>
                  </div>
                </div>
              </ng-container>
              <ng-template #bannerUploadPlaceholder>
                <h3>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 3.5H10C6.22876 3.5 4.34315 3.5 3.17157 4.67157C2 5.84315 2 7.72876 2 11.5V13.5C2 17.2712 2 19.1569 3.17157 20.3284C4.34315 21.5 6.22876 21.5 10 21.5H14C17.7712 21.5 19.6569 21.5 20.8284 20.3284C22 19.1569 22 17.2712 22 13.5V11.5C22 7.72876 22 5.84315 20.8284 4.67157C19.6569 3.5 17.7712 3.5 14 3.5Z"
                      stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M8.5 10.5C9.32843 10.5 10 9.82843 10 9C10 8.17157 9.32843 7.5 8.5 7.5C7.67157 7.5 7 8.17157 7 9C7 9.82843 7.67157 10.5 8.5 10.5Z"
                      stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M21.5 17.5L16.348 11.8797C16.1263 11.6377 15.8131 11.5 15.485 11.5C15.1744 11.5 14.8766 11.6234 14.6571 11.8429L10 16.5L7.83928 14.3393C7.62204 14.122 7.32741 14 7.02019 14C6.68931 14 6.37423 14.1415 6.15441 14.3888L2.5 18.5"
                      stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Upload engagement banner
                  <span nz-tooltip nzTooltipTitle="{{ 'addContests.banner.tooltip' | translate }}"
                    nzTooltipPlacement="top">
                    <i class="fa-solid fa-circle-info info"></i>
                  </span>
                </h3>
                <p>
                  Browse images optimal dimension <span>375*321</span> . Supported format JPEG, PNG. Max photo size 2
                  MB.
                </p>
              </ng-template>
              <input type="file" #profileFileInput accept=".png, .jpg, .jpeg" (change)="onBannerFileSelected($event)"
                style="display: none" />
            </div>
            <div class="luqta-card">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="" class="form-label">{{ 'addContests.contestName.label' | translate
                      }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.contestName.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <input type="text" id="contestName" formControlName="name" class="form-control"
                      [placeholder]="'addContests.contestName.placeholder' | translate">
                    <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                      <small class="error text-danger" *ngIf=" !isSavingDraft &&
                    addContentForm.controls['name'].invalid &&
                    addContentForm.controls['name'].touched
                  ">
                        <span class="text-left" *ngIf="addContentForm.controls['name'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group rtl">
                    <label for="arabic_name" class="form-label">
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.contestArabicName.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>

                      <span>*</span> {{ 'addContests.contestArabicName.label' | translate }}

                    </label>
                    <input type="text" class="form-control" formControlName="arabic_name" id="arabic_name"
                      [placeholder]="'addContests.contestArabicName.placeholder' | translate">
                    <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                      <small class="error text-danger" *ngIf=" !isSavingDraft &&
                    addContentForm.controls['arabic_name'].invalid &&
                    addContentForm.controls['arabic_name'].touched
                  ">
                        <span *ngIf="addContentForm.controls['arabic_name'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label for="contest-detail" class="form-label">{{ 'addContests.description.label' | translate
                      }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.description.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <input id="contestDetails" class="form-control" formControlName="details" maxlength="1000"
                      [placeholder]="'addContests.description.placeholder' | translate">
                    <!-- Character counter inside textarea (top-right) -->
                    <div class="character-counter">
                      <small [ngClass]="{
                    'text-danger': addContentForm.get('details')?.value?.length === 1000,
                    'text-dark': addContentForm.get('details')?.value?.length < 1000
                    }" *ngIf="addContentForm.get('details')?.value?.length >= 0">
                        {{ addContentForm.get('details')?.value?.length || 0 }}/1000
                      </small>
                    </div>
                  </div>
                  <div class="px-1 w-100 mt-2">
                    <small class="error text-danger"
                      *ngIf="!isSavingDraft && addContentForm.controls['details'].invalid && addContentForm.controls['details'].touched">
                      <span *ngIf="addContentForm.controls['details'].errors?.['required']">
                        {{ "addContestsValidation.required" | translate }}
                      </span>
                    </small>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group rtl">
                    <label for="" class="form-label">
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.arabicDescription.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                      <span>*</span>{{ 'addContests.arabicDescription.label' | translate }}
                    </label>
                    <input type="text" id="arabic_details" class="form-control" formControlName="arabic_details"
                      maxlength="1000" [placeholder]="'addContests.arabicDescription.placeholder' | translate">
                    <!-- Character counter inside textarea (top-right) -->
                    <div class="character-counter">
                      <small [ngClass]="{
                     'text-danger': addContentForm.get('arabic_details')?.value?.length === 1000,
                     'text-dark': addContentForm.get('arabic_details')?.value?.length < 1000
                      }" *ngIf="addContentForm.get('arabic_details')?.value?.length >= 0">
                        {{ addContentForm.get('arabic_details')?.value?.length || 0 }}/1000
                      </small>
                    </div>
                    <!-- Error messages below -->
                    <div class="px-1 w-100 mt-2">
                      <small class="error text-danger"
                        *ngIf="!isSavingDraft && addContentForm.controls['arabic_details'].touched && addContentForm.controls['arabic_details'].invalid">
                        <span *ngIf="addContentForm.controls['arabic_details'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                        <span *ngIf="addContentForm.controls['arabic_details'].errors?.['maxlength']">
                          {{ "addContestsValidation.maxLength" | translate : { max: 1000 } }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="luqta-card">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group position-relative">
                    <label for="" class="form-label">{{ 'addContests.age.label' | translate }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.age.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <nz-select nzMode="multiple" [nzPlaceHolder]="'addContests.age.placeholder' | translate"
                      class="form-control-select" formControlName="age">
                      <nz-option *ngFor="let range of ageRanges" [nzLabel]="range" [nzValue]="range"></nz-option>
                    </nz-select>
                    <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                      <small class="error text-danger" *ngIf="!isSavingDraft &&
        addContentForm.controls['age'].invalid &&
        addContentForm.controls['age'].touched">
                        <span *ngIf="addContentForm.controls['age'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <!-- Gender Multi-Select -->
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="" class="form-label">{{ 'addContests.gender.label' | translate }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.gender.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <select class="custom-select" formControlName="gender">
                      <option disabled selected>{{ 'addContests.gender.placeholder' | translate }}</option>
                      <option value="male">{{ 'addContests.gender.male' | translate }}</option>
                      <option value="female">{{ 'addContests.gender.female' | translate }}</option>
                      <option value="both">{{ 'addContests.gender.both' | translate }}</option>
                    </select>

                    <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                      <small class="error text-danger" *ngIf=" !isSavingDraft &&
                    addContentForm.controls['gender'].invalid &&
                    addContentForm.controls['gender'].touched
                  ">
                        <span *ngIf="addContentForm.controls['gender'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Location Multi-Select -->
                <div class="col-lg-4">
                  <div class="form-group position-relative">
                    <label for="" class="form-label">{{ 'addContests.location.label' | translate
                      }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.location.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>

                    </label>
                    <nz-cascader [nzOptions]="locationOptions" [ngModel]="locationCascaderValue"
                      (ngModelChange)="onLocationCascaderChange($event)" [ngModelOptions]="{standalone: true}"
                      [nzPlaceHolder]="'addContests.location.placeholder' | translate"
                      class="form-control-qr category-cascader" [nzShowSearch]="cascaderSearchOption" [nzChangeOnSelect]="true"
                      [nzMultiple]="true" nzExpandTrigger="hover" [nzColumnClassName]="'category-cascader-column'"
                      (nzVisibleChange)="onLocationDropdownOpen($event)">
                    </nz-cascader>
                    <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                      <small class="error text-danger" *ngIf="!isSavingDraft &&
        addContentForm.controls['location'].invalid &&
        addContentForm.controls['location'].touched">
                        <span *ngIf="addContentForm.controls['location'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Participant Interests -->
                <div class="col-lg-4">
                  <div class="form-group position-relative">
                    <label class="form-label">Business Objective<span>*</span>
                      <span nz-tooltip nzTooltipTitle="Select the objective of this engagement" nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <nz-cascader [nzOptions]="interestOptions" [ngModel]="interestCascaderValue"
                      (ngModelChange)="onInterestCascaderChange($event)" [ngModelOptions]="{standalone: true}"
                      nzPlaceHolder="Select interest" class="form-control-qr category-cascader" [nzShowSearch]="true"
                      [nzChangeOnSelect]="true" [nzMultiple]="true" nzExpandTrigger="hover"
                      (nzVisibleChange)="onBusinessObjectiveVisibleChange($event)"
                      [nzColumnClassName]="'category-cascader-column'">
                    </nz-cascader>
                    <small class="error text-danger" *ngIf="!isSavingDraft &&
                      addContentForm.get('business_objective')?.invalid &&
                      addContentForm.get('business_objective')?.touched">
                      Business Objective is required.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <!-- SDK Features Section -->
            <div class="luqta-card" *ngIf="hasSdkAccess">
              <div class="row">
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label class="form-label">Draw Type<span>*</span></label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['draw_type'].value === 'random_draw'"
                          (click)="onDrawTypeChange('random_draw')">
                          Random Draw
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['draw_type'].value === 'first_to_complete'"
                          (click)="onDrawTypeChange('first_to_complete')">
                          First To Complete
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['draw_type'].value === 'top_points'"
                          (click)="onDrawTypeChange('top_points')">
                          {{ 'add-content.top-points-draw' | translate }}
                        </a>
                      </div>
                      <small class="error text-danger" *ngIf="!isSavingDraft &&
                        addContentForm.controls['draw_type'].invalid &&
                        addContentForm.controls['draw_type'].touched">
                        <span *ngIf="addContentForm.controls['draw_type'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label class="form-label">Number of Participants<span>*</span>
                        <span class="text-muted" style="font-size: 12px; font-weight: 400;" *ngIf="maxParticipants"> (Max: {{ maxParticipants }})</span>
                      </label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['no_of_users'].value === 10 && !isCustomParticipants"
                          (click)="addContentForm.patchValue({no_of_users: 10}); isCustomParticipants = false; addContentForm.controls['no_of_users'].markAsTouched()">
                          10
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['no_of_users'].value === 50 && !isCustomParticipants"
                          (click)="addContentForm.patchValue({no_of_users: 50}); isCustomParticipants = false; addContentForm.controls['no_of_users'].markAsTouched()">
                          50
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['no_of_users'].value === 100 && !isCustomParticipants"
                          (click)="addContentForm.patchValue({no_of_users: 100}); isCustomParticipants = false; addContentForm.controls['no_of_users'].markAsTouched()">
                          100
                        </a>
                        <span>Or</span>
                        <input type="number" class="form-control" style="max-width: 100px; display: inline-block;"
                          formControlName="no_of_users" [placeholder]="'Enter'" min="1"
                          (focus)="isCustomParticipants = true"
                          (input)="isCustomParticipants = true; addContentForm.controls['no_of_users'].markAsTouched()" />
                      </div>
                      <small class="error text-danger" *ngIf="!isSavingDraft &&
                        addContentForm.controls['no_of_users'].invalid &&
                        addContentForm.controls['no_of_users'].touched">
                        <span *ngIf="addContentForm.controls['no_of_users'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                        <span *ngIf="addContentForm.controls['no_of_users'].errors?.['max']">
                          Cannot exceed Points Pool Per Contest ({{ addContentForm.controls['points_pool_per_contest'].value | number }})
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="luqta-card">
              <div class="row">
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label for="type" class="form-label">
                        {{ "addContests.type.label" | translate }}<span>*</span>
                        <span nz-tooltip nzTooltipTitle="{{ 'addContests.type.tooltip' | translate }}"
                          nzTooltipPlacement="top">
                          <i class="fa-solid fa-circle-info info"></i>
                        </span>
                      </label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['type'].value === 'public'"
                          (click)="addContentForm.patchValue({type: 'public'}); addContentForm.controls['type'].markAsTouched()">
                          {{ 'addContests.type.public' | translate }}
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['type'].value === 'private'"
                          (click)="addContentForm.patchValue({type: 'private'}); addContentForm.controls['type'].markAsTouched()">
                          {{ 'addContests.type.private' | translate }}
                        </a>
                      </div>
                      <small class="error text-danger" *ngIf="!isSavingDraft && 
                  addContentForm.controls['type'].invalid && 
                  addContentForm.controls['type'].touched">
                        <span *ngIf="addContentForm.controls['type'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label for="sharingSetting" class="form-label">
                        {{ "addContests.sharingSetting.label" | translate }}<span>*</span>
                        <span nz-tooltip nzTooltipTitle="{{ 'addContests.sharingSetting.tooltip' | translate }}"
                          nzTooltipPlacement="top">
                          <i class="fa-solid fa-circle-info info"></i>
                        </span>
                      </label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['sharingSetting'].value === 'share'"
                          (click)="addContentForm.patchValue({sharingSetting: 'share'}); addContentForm.controls['sharingSetting'].markAsTouched()">
                          {{ 'addContests.sharingSetting.share' | translate }}
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['sharingSetting'].value === 'single'"
                          (click)="addContentForm.patchValue({sharingSetting: 'single'}); addContentForm.controls['sharingSetting'].markAsTouched()">
                          {{ 'addContests.sharingSetting.single' | translate }}
                        </a>
                      </div>
                      <small class="error text-danger" *ngIf="!isSavingDraft && 
                    addContentForm.controls['sharingSetting'].invalid && 
                    addContentForm.controls['sharingSetting'].touched">
                        <span *ngIf="addContentForm.controls['sharingSetting'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label for="number_of_winners" class="form-label">
                        {{ "addContests.numberOfWinners.label" | translate }}<span>*</span>
                        <span nz-tooltip nzTooltipTitle="{{ 'addContests.numberOfWinners.tooltip' | translate }}"
                          nzTooltipPlacement="top">
                          <i class="fa-solid fa-circle-info info"></i>
                        </span>
                      </label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['number_of_winners'].value === 1 && !isCustomInput"
                          (click)="addContentForm.patchValue({number_of_winners: 1}); isCustomInput = false; addContentForm.controls['number_of_winners'].markAsTouched()">
                          1
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['number_of_winners'].value === 2 && !isCustomInput"
                          (click)="addContentForm.patchValue({number_of_winners: 2}); isCustomInput = false; addContentForm.controls['number_of_winners'].markAsTouched()">
                          2
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['number_of_winners'].value === 3 && !isCustomInput"
                          (click)="addContentForm.patchValue({number_of_winners: 3}); isCustomInput = false; addContentForm.controls['number_of_winners'].markAsTouched()">
                          3
                        </a>
                        <span>Or</span>
                        <input type="number" class="form-control" style="max-width: 100px; display: inline-block;"
                          formControlName="number_of_winners" [placeholder]="'Enter'" min="1"
                          (focus)="isCustomInput = true"
                          (input)="isCustomInput = true; addContentForm.controls['number_of_winners'].markAsTouched()" />
                      </div>

                      <small class="error text-danger" *ngIf="!isSavingDraft && 
                    addContentForm.controls['number_of_winners'].invalid && 
                    addContentForm.controls['number_of_winners'].touched">
                        <span *ngIf="addContentForm.controls['number_of_winners'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                        <span *ngIf="addContentForm.controls['number_of_winners'].errors?.['min']">
                          {{ "addContestsValidation.required_not_negative" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label for="points_pool_per_contest" class="form-label">
                        Points Pool Per Contest
                      </label>
                      <input
                        type="number"
                        id="points_pool_per_contest"
                        class="form-control"
                        formControlName="points_pool_per_contest"
                        placeholder="Enter points pool"
                        min="0"
                      />
                      <small *ngIf="remainingPoints > 0" class="text-muted mt-1 d-block">
                        Max: {{ remainingPoints | number }} remaining points
                      </small>
                      <small class="error text-danger" *ngIf="addContentForm.controls['points_pool_per_contest'].touched">
                        <span *ngIf="addContentForm.controls['points_pool_per_contest'].errors?.['min']">Value cannot be negative</span>
                        <span *ngIf="addContentForm.controls['points_pool_per_contest'].errors?.['max']">Cannot exceed remaining points ({{ remainingPoints | number }})</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="w-fc">
                    <div class="form-group">
                      <label for="format_of_contest" class="form-label">
                        {{ "addContests.formatOfContest.label" | translate }}<span>*</span>
                        <span nz-tooltip nzTooltipTitle="{{ 'addContests.formatOfContest.tooltip' | translate }}"
                          nzTooltipPlacement="top">
                          <i class="fa-solid fa-circle-info info"></i>
                        </span>
                      </label>
                      <div class="select-options">
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['format_of_contest'].value === 'non-integrated'"
                          (click)="addContentForm.patchValue({format_of_contest: 'non-integrated'}); addContentForm.controls['format_of_contest'].markAsTouched()">
                          {{ 'addContests.formatOfContest.nonIntegrated' | translate }}
                        </a>
                        <a href="javascript:void(0)" class="option"
                          [class.active]="addContentForm.controls['format_of_contest'].value === 'integrated'"
                          (click)="addContentForm.patchValue({format_of_contest: 'integrated'}); addContentForm.controls['format_of_contest'].markAsTouched()">
                          {{ 'addContests.formatOfContest.integrated' | translate }}
                        </a>
                      </div>
                      <small class="error text-danger" *ngIf="!isSavingDraft && 
                    addContentForm.controls['format_of_contest'].invalid && 
                    addContentForm.controls['format_of_contest'].touched">
                        <span *ngIf="addContentForm.controls['format_of_contest'].errors?.['required']">
                          {{ "addContestsValidation.required" | translate }}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="luqta-card">
              <div class="row">
                <!-- Start Date -->
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="start_date" class="form-label">
                      {{ "addContests.startDate.label" | translate }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.startDate.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <nz-date-picker formControlName="start_date" class="custom-select"
                      [nzPlaceHolder]="'addContests.startDate.placeholder' | translate" nzShowTime
                      nzFormat="dd/MM/yy hh:mm a" [nzDisabledDate]="getDisabledStartDate"
                      [nzDisabledTime]="getDisabledStartDateTime">
                    </nz-date-picker>
                    <small class="error text-danger" *ngIf="!isSavingDraft && 
                  addContentForm.controls['start_date'].invalid && 
                  addContentForm.controls['start_date'].touched">
                      <span *ngIf="addContentForm.controls['start_date'].errors?.['required']">
                        {{ "addContestsValidation.required" | translate }}
                      </span>
                    </small>
                  </div>
                </div>

                <!-- End Date -->
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="end_date" class="form-label">
                      {{ "addContests.endDate.label" | translate }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.endDate.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <nz-date-picker formControlName="end_date" class="custom-select"
                      [nzPlaceHolder]="'addContests.endDate.placeholder' | translate" nzShowTime
                      nzFormat="dd/MM/yy hh:mm a" [nzDisabledDate]="getDisabledEndDate"
                      [nzDisabledTime]="getDisabledEndDateTime">
                    </nz-date-picker>
                    <small class="error text-danger" *ngIf="!isSavingDraft && 
                  addContentForm.controls['end_date'].invalid && 
                  addContentForm.controls['end_date'].touched">
                      <span *ngIf="addContentForm.controls['end_date'].errors?.['required']">
                        {{ "addContestsValidation.required" | translate }}
                      </span>
                    </small>
                  </div>
                </div>

                <!-- Prize Announce Date -->
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for="prize_announce_date" class="form-label">
                      {{ "addContests.prizeAnnounceDate.label" | translate }}<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.prizeAnnounceDate.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <nz-date-picker formControlName="prize_announce_date" class="custom-select"
                      [nzPlaceHolder]="'addContests.prizeAnnounceDate.placeholder' | translate" nzShowTime
                      nzFormat="dd/MM/yy hh:mm a" [nzDisabledDate]="getDisabledPrizeDate"
                      [nzDisabledTime]="getDisabledPrizeDateTime">
                    </nz-date-picker>
                    <small class="error text-danger" *ngIf="!isSavingDraft && 
                  addContentForm.controls['prize_announce_date'].invalid && 
                  addContentForm.controls['prize_announce_date'].touched">
                      <span *ngIf="addContentForm.controls['prize_announce_date'].errors?.['required']">
                        {{ "addContestsValidation.required" | translate }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <!-- End Step 1 -->

          <!-- Step 2: Prizes Details -->
          <div *ngIf="currentStep === 2">
            <div formArrayName="_contest_prize">
              <div class="luqta-card" *ngFor="let prize_group of prizes.controls; let i = index" [formGroupName]="i">
                <div class="main-div position-relative mb-3">

                  <!-- Remove Prize Icon -->
                  <div class="position-absolute top-0 end-0" style="width: auto; z-index: 100">
                    <svg *ngIf="prizes.controls.length > 1" class="cross-icon" xmlns="http://www.w3.org/2000/svg"
                      width="24" height="24" viewBox="0 0 24 24" fill="none" (click)="confirmRemovePrize(i)"
                      style="cursor: pointer">
                      <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#FF3B30" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                        stroke="#FF3B30" stroke-width="1.5" />
                    </svg>
                  </div>







                  <!-- Contest Prize & Value Fields -->
                  <div class="row">

                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="type" class="form-label">
                          {{ "addContests.contestPrize.select" | translate }}
                          <span>*</span>
                          <span class="label_subtext mx-2">
                            <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_type_tooltip' | translate }}">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <nz-cascader [nzOptions]="prizeCategoryOptions[i] || categoriesTree"
                          [nzPlaceHolder]="'addContests.contestPrize.selectPlaceholder' | translate"
                          class="form-control-qr category-cascader" formControlName="category_type"
                          [nzShowSearch]="true" [nzChangeOnSelect]="true" [nzMultiple]="true" nzExpandTrigger="hover"
                          [nzColumnClassName]="'category-cascader-column'"
                          (nzVisibleChange)="onCategoryDropdownOpen($event)">
                        </nz-cascader>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && prize_group.get('category_type')?.invalid && prize_group.get('category_type')?.touched">
                          {{ "addContestsValidation.required" | translate }}
                        </small>
                      </div>
                    </div>





                    <div class="col-lg-6">
                      <div class="form-group position-relative">
                        <label [for]="'prizeName_' + i" class="form-label">
                          {{ "addContests.contestPrize.label" | translate }}
                          <span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'addContests.contestPrize.tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>
                        </label>
                        <input type="text" [id]="'prizeName_' + i" formControlName="name" class="form-control"
                          placeholder="{{ 'addContests.contestPrize.placeholder' | translate }}" />

                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && prize_group.get('name')?.invalid && prize_group.get('name')?.touched">
                          <span *ngIf="prize_group.get('name')?.errors?.['required']">
                            {{ "addContestsValidation.required" | translate }}
                          </span>
                        </small>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group position-relative">
                        <label [for]="'prizeValue_' + i" class="form-label">
                          {{ "addContests.contestValue.label" | translate }}
                          <span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'addContests.contestValue.tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>

                        </label>
                        <input type="number" step="any" min="0" [id]="'prizeValue_' + i" formControlName="value"
                          class="form-control" placeholder="{{ 'addContests.contestValue.placeholder' | translate }}" />

                        <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                          <small class="error text-danger"
                            *ngIf="!isSavingDraft && prize_group.get('value')?.invalid && prize_group.get('value')?.touched">
                            <span *ngIf="prize_group.get('value')?.errors?.['required']">
                              {{ "addContests.contestValue.validation" | translate }}
                            </span>
                            <span *ngIf="prize_group.get('value')?.errors?.['min']">
                              {{ 'addContests.contestValue.minValidation' | translate }}
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>

                    <!-- Upload Prize Image -->
                    <div class="col-12 mb-4">
                      <div class="position-relative">

                        <!-- Uploaded Image Preview -->
                        <ng-container *ngIf="imagePreview[i]?.image_code; else prizeImagePlaceholder">
                          <div class="position-relative" [style.margin-top.px]="i === prizes.controls.length - 1 ">
                            <div (click)="triggerPrizeFileInput(i)" style="cursor: pointer;">
                              <img [src]="imgPrizeSrc(i)" alt="Prize Preview" class="image w-100"
                                style="border-radius: 8px; max-height: 162px; object-fit: cover; top: -30px; z-index: 10" />
                            </div>
                            <!-- Preview Icon -->
                            <button class="img-preview-btn prize-preview-btn" (click)="openImagePreview(imgPrizeSrc(i) || '', '' + (prizeArray.at(i).get('name')?.value ?? 'Prize'), $event)" title="Full Preview">
                              <i class="fa-solid fa-expand"></i>
                            </button>
                            <!-- AI Regenerate Icon -->
                            <button *ngIf="hasAiAccess" class="img-preview-btn prize-ai-regen-btn" (click)="openAiRegenModal($event, 'prize', i)" title="Generate with AI">
                              <i class="fa-solid fa-wand-magic-sparkles"></i>
                            </button>
                            <!-- Delete Icon -->
                            <svg class="cross-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                              viewBox="0 0 24 24" fill="none" (click)="deletePrizeImage(i)" style="
                          cursor: pointer;
                          position: absolute;
                          top: 8px;
                          right: 8px;
                          background: white;
                          border-radius: 50%;
                          padding: 4px;
                     ">
                              <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#FF3B30" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                stroke="#FF3B30" stroke-width="1.5" />
                            </svg>
                          </div>
                        </ng-container>

                        <!-- File Input (Hidden) -->
                        <input type="file" #prizeFileInput [id]="'prizeFileInput' + i" accept=".png, .jpg, .jpeg"
                          (change)="handleFileSelection($event, 'image_code', i)" style="display: none" />

                        <!-- Upload Card Placeholder -->
                        <ng-template #prizeImagePlaceholder>
                          <div class="upload-logo-card" (click)="triggerPrizeFileInput(i)" style="cursor: pointer;">
                            <!-- Upload Content (Clickable Area) -->
                            <div class="text-center">
                              <h3 class="d-flex align-items-center justify-content-center gap-2">
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M14 3.5H10C6.22876 3.5 4.34315 3.5 3.17157 4.67157C2 5.84315 2 7.72876 2 11.5V13.5C2 17.2712 2 19.1569 3.17157 20.3284C4.34315 21.5 6.22876 21.5 10 21.5H14C17.7712 21.5 19.6569 21.5 20.8284 20.3284C22 19.1569 22 17.2712 22 13.5V11.5C22 7.72876 22 5.84315 20.8284 4.67157C19.6569 3.5 17.7712 3.5 14 3.5Z"
                                    stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path
                                    d="M8.5 10.5C9.32843 10.5 10 9.82843 10 9C10 8.17157 9.32843 7.5 8.5 7.5C7.67157 7.5 7 8.17157 7 9C7 9.82843 7.67157 10.5 8.5 10.5Z"
                                    stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path
                                    d="M21.5 17.5L16.348 11.8797C16.1263 11.6377 15.8131 11.5 15.485 11.5C15.1744 11.5 14.8766 11.6234 14.6571 11.8429L10 16.5L7.83928 14.3393C7.62204 14.122 7.32741 14 7.02019 14C6.68931 14 6.37423 14.1415 6.15441 14.3888L2.5 18.5"
                                    stroke="#141B34" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </svg>
                                Upload Prize Image
                                <span nz-tooltip nzTooltipTitle="{{ 'addContests.prizeImage.tooltip' | translate }}"
                                  nzTooltipPlacement="top">
                                  <i class="fa-solid fa-circle-info info"></i>
                                </span>
                              </h3>
                              <p class="mb-0">
                                Browse images optimal dimension <span>375*321</span>. Supported format JPEG, PNG. Max
                                photo
                                size 5 MB.
                              </p>
                            </div>
                          </div>
                        </ng-template>

                        <!-- Validation Message -->
                        <div class="px-1 w-100 position-absolute mt-2" style="bottom: -25px">
                          <small class="error text-danger"
                            *ngIf="!isSavingDraft && prizeArray.at(i).get('image_code')?.invalid && prizeArray.at(i).get('image_code')?.touched">
                            <span *ngIf="prizeArray.at(i).get('image_code')?.errors?.['required']">
                              {{ "addContestsValidation.prizeImageRequired" | translate }}
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <!-- Add More Prize Button (outside prize box) -->
            <div class="d-flex justify-content-center mt-2 mb-2" *ngIf="prizes.controls.length > 0">
              <button type="button" class="btn btn-add-more-prize" (click)="addPrize()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="margin-right: 8px; vertical-align: middle;">
                  <circle cx="10" cy="10" r="9" stroke="white" stroke-width="1.5" />
                  <path d="M10 6V14M6 10H14" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                {{ "addContests.addMorePrize" | translate }}
              </button>
            </div>
          </div>
          <!-- End Step 2 -->

          <!-- Step 3: Levels Details -->
          <div *ngIf="currentStep === 3">
            <!-- Level Count Selection -->
            <div class="luqta-card mb-3">
              <div class="row">
                <div class="col-lg-8">
                  <div class="form-group">
                    <label for="number_of_levels" class="form-label">
                      Select number of levels<span>*</span>
                      <span nz-tooltip nzTooltipTitle="{{ 'addContests.numberOfLevels.tooltip' | translate }}"
                        nzTooltipPlacement="top">
                        <i class="fa-solid fa-circle-info info"></i>
                      </span>
                    </label>
                    <div class="select-options">
                      <a href="javascript:void(0)" class="option"
                        [class.active]="selectedLevelCount === 1 && !customLevelCount"
                        [class.disabled]="isFirstToComplete()"
                        [style.opacity]="isFirstToComplete() ? '0.4' : '1'"
                        [style.cursor]="isFirstToComplete() ? 'not-allowed' : 'pointer'"
                        (click)="setLevelCount(1)">1</a>
                      <a href="javascript:void(0)" class="option"
                        [class.active]="selectedLevelCount === 2 && !customLevelCount" (click)="setLevelCount(2)">2</a>
                      <a href="javascript:void(0)" class="option"
                        [class.active]="selectedLevelCount === 3 && !customLevelCount" (click)="setLevelCount(3)">3</a>
                      <a href="javascript:void(0)" class="option"
                        [class.active]="selectedLevelCount === 4 && !customLevelCount" (click)="setLevelCount(4)">4</a>
                      <a href="javascript:void(0)" class="option"
                        [class.active]="selectedLevelCount === 5 && !customLevelCount" (click)="setLevelCount(5)">5</a>
                      <span>Or</span>
                      <input type="number" class="form-control  " style="max-width: 120px; display: inline-block;"
                        [min]="isFirstToComplete() ? 2 : 1" max="20" [(ngModel)]="customLevelCount" (ngModelChange)="onCustomLevelInput($event)"
                        [ngModelOptions]="{standalone: true}" placeholder="Enter" />
                    </div>
                    <small class="text-muted d-block mt-2" style="font-size: 12px;">Maximum 20 levels allowed</small>
                    <small *ngIf="isFirstToComplete()" class="text-warning d-block mt-1" style="font-size: 12px;">"First To Complete" requires at least 2 levels</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dynamic Levels -->
            <div formArrayName="levels_of_contest" class="levels-section">
              <ng-container *ngFor="let level of levels.controls; let i = index">
                <!-- Level Heading Outside Card -->
                <h3 class="level-heading mb-3">Level {{ i + 1 }}</h3>

                <div class="luqta-card mb-3" [formGroupName]="i">
                  <!-- Delete Icon (shown when more than one level exists) -->
                  <div class="d-flex justify-content-end mb-3" *ngIf="levels.controls.length > 1">
                    <svg class="cross-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" (click)="confirmRemoveLevel(i)" style="cursor: pointer">
                      <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="#FF3B30" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                        stroke="#FF3B30" stroke-width="1.5" />
                    </svg>
                  </div>

                  <div class="row">
                    <!-- Level Name (English) -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'name_' + i" class="form-label">
                          {{ "Levels_Array.Level_Name" | translate }}
                          <span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_Name_tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>

                        </label>
                        <input type="text" [id]="'name_' + i" class="form-control" formControlName="name"
                          [placeholder]="'Levels_Array.Level_Name_Placeholder' | translate" />
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('name')?.invalid && level.get('name')?.touched">
                          {{'Levels_Array.Level_Name_validation' | translate}}
                        </small>
                      </div>
                    </div>

                    <!-- Level Name (Arabic) -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'arabic_name_' + i" class="form-label">
                          {{ "addContests.contestArabicName.level_label" | translate }}<span>*</span>
                          <span nz-tooltip
                            nzTooltipTitle="{{ 'addContests.contestArabicName.level_tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>

                        </label>

                        <input type="text" [id]="'arabic_name_' + i" class="form-control" formControlName="arabic_name"
                          [placeholder]="'addContests.contestArabicName.level_placeholder' | translate" />
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('arabic_name')?.touched && level.get('arabic_name')?.invalid">
                          <span *ngIf="level.get('arabic_name')?.errors?.['required']">
                            {{ "addContestsValidation.required" | translate }}
                          </span>
                        </small>
                      </div>
                    </div>

                    <!-- Description (English) -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'description_' + i" class="form-label">
                          {{ "Levels_Array.Level_description" | translate }}<span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_description_tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>
                        </label>
                        <textarea [id]="'description_' + i" formControlName="description" class="form-control" rows="4"
                          maxlength="1000"
                          [placeholder]="'Levels_Array.Level_description_placeholder' | translate"></textarea>

                        <!-- Character counter -->
                        <div class="character-counter">
                          <small [ngClass]="{
        'text-danger': (level.get('description')?.value?.length || 0) === 1000,
        'text-dark': (level.get('description')?.value?.length || 0) < 1000
      }">
                            {{ level.get('description')?.value?.length || 0 }}/1000
                          </small>
                        </div>

                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('description')?.touched && level.get('description')?.invalid">
                          <span *ngIf="level.get('description')?.errors?.['required']">
                            {{ 'addContestsValidation.required' | translate }}
                          </span>
                        </small>
                      </div>
                    </div>
                    <!-- Description (Arabic) -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'arabic_description_' + i" class="form-label">
                          {{ "addContests.arabicDescription.label" | translate }}<span>*</span>
                        </label>
                        <textarea [id]="'arabic_description_' + i" formControlName="arabic_description"
                          class="form-control" rows="4" maxlength="1000"
                          [placeholder]="'addContests.arabicDescription.placeholder' | translate"></textarea>

                        <!-- Character counter -->
                        <div class="character-counter">
                          <small [ngClass]="{
        'text-danger': (level.get('arabic_description')?.value?.length || 0) === 1000,
        'text-dark': (level.get('arabic_description')?.value?.length || 0) < 1000
      }">
                            {{ level.get('arabic_description')?.value?.length || 0 }}/1000
                          </small>
                        </div>

                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('arabic_description')?.touched && level.get('arabic_description')?.invalid">
                          <span *ngIf="level.get('arabic_description')?.errors?.['required']">
                            {{ "addContestsValidation.required" | translate }}
                          </span>
                        </small>
                      </div>
                    </div>

                    <!-- Level Type -->
                    <div class="col-lg-4">
                      <div class="form-group">
                        <label for="type" class="form-label">
                          {{ "Levels_Array.Level_type" | translate }}
                          <span>*</span>
                          <span class="label_subtext mx-2">
                            <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_type_tooltip' | translate }}">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <nz-select nzShowSearch nzAllowClear
                          [nzPlaceHolder]="'Levels_Array.Level_type_placeholder' | translate" class="form-control-qr"
                          formControlName="type">
                          <nz-option nzLabel="Text" nzValue="text"></nz-option>
                          <nz-option nzLabel="QR Code" nzValue="qr"></nz-option>
                          <nz-option nzLabel="Image" nzValue="image"></nz-option>
                          <nz-option [nzLabel]="'Levels_Array.Level_type_quiz' | translate" nzValue="quiz"></nz-option>
                          <nz-option [nzLabel]="'add-content.survey-level' | translate" nzValue="survey"></nz-option>
                          <nz-option [nzLabel]="'add-content.link-task-level' | translate" nzValue="link_task"></nz-option>
                          <nz-option *ngIf="addContentForm.value.format_of_contest === 'integrated'"
                            nzLabel="Luqta Webhook" nzValue="luqta_weebhook"></nz-option>
                          <nz-option *ngIf="addContentForm.value.format_of_contest === 'integrated'"
                            nzLabel="Client Webhook" nzValue="client_webhook"></nz-option>
                        </nz-select>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('type')?.invalid && level.get('type')?.touched">
                          {{'Levels_Array.Level_type_validation' | translate}}
                        </small>
                      </div>
                    </div>

                    <!-- Level Start Date & Time -->
                    <div class="col-lg-4">
                      <div class="form-group">
                        <label [for]="'level_start_date_' + i" class="form-label">
                          Level start date & time
                          <span>*</span>
                          <span nz-tooltip nzTooltipTitle="Select when this level starts" nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>
                        </label>
                        <nz-date-picker formControlName="level_start_date" class="custom-select" nzShowTime
                          nzFormat="dd/MM/yy hh:mm a" nzPlaceHolder="dd/mm/yy hh:mm am"
                          [nzDisabledDate]="getDisabledLevelStartDate(i)"
                          [nzDisabledTime]="getDisabledLevelStartDateTime(i)">
                        </nz-date-picker>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('level_start_date')?.invalid && level.get('level_start_date')?.touched">
                          Level start date & time is required.
                        </small>
                      </div>
                    </div>

                    <!-- Luqta Webhook Endpoint (hardcoded, copyable) -->
                    <div *ngIf="level.get('type')?.value === 'luqta_weebhook'" class="col-lg-4">
                      <div class="form-group">
                        <label class="form-label">Luqta Webhook Endpoint</label>
                        <div style="display:flex; align-items:center; gap:8px; padding:10px 14px; background:#f0f5ff; border-radius:10px; border:1px solid #e2e8f0; height:48px;">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="flex-shrink:0;">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="#6c63ff" stroke-width="2" stroke-linecap="round"/>
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="#6c63ff" stroke-width="2" stroke-linecap="round"/>
                          </svg>
                          <span style="flex:1; font-size:13px; color:#2E3B55; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-family:'Inter',sans-serif;">
                            https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook
                          </span>
                          <button type="button" title="Copy URL"
                                  style="background:none; border:none; cursor:pointer; padding:4px; display:flex; align-items:center;"
                                  (click)="copyHardcodedLuqtaWebhookUrl()">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                              <rect x="9" y="9" width="11" height="11" rx="2" stroke="#2E3B55" stroke-width="1.5"/>
                              <path d="M5 15V5a2 2 0 0 1 2-2h10" stroke="#2E3B55" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Level Timeline -->
                    <div class="col-lg-4">
                      <div class="form-group">
                        <label [for]="'level_timeline_' + i" class="form-label">
                          {{ 'Levels_Array.Level_timeline' | translate}}<span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_timeline_tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>

                        </label>

                        <nz-date-picker formControlName="level_timeline" class="custom-select" nzShowTime
                          nzFormat="dd/MM/yy hh:mm a"
                          [nzPlaceHolder]="'Levels_Array.Level_timeline_placeholder' | translate"
                          [nzDisabledDate]="getDisabledLevelDate(i)" [nzDisabledTime]="getDisabledLevelDateTime(i)">
                        </nz-date-picker>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('level_timeline')?.invalid && level.get('level_timeline')?.touched">
                          {{ 'Levels_Array.Level_timeline_required' | translate }}
                        </small>
                        <small class="error text-warning d-block mt-1"
                          *ngIf="!isSavingDraft && !level.get('level_timeline')?.value && i > 0 && !getPreviousLevelDate(i)">
                          {{ 'Levels_Array.Level_timeline_select_previous' | translate:{level: i} }}
                        </small>
                        <small class="error text-danger d-block mt-1"
                          *ngIf="!isSavingDraft && level.errors?.['levelDateOrder'] && (level.get('level_start_date')?.touched || level.get('level_timeline')?.touched)">
                          Start date & time must be before level expiry date & time.
                        </small>
                      </div>
                    </div>

                    <!-- Total Points per Level -->

                    <!-- Conditional Content Fields Based on Type -->

                    <!-- Text Type -->
                    <div *ngIf="level.get('type')?.value === 'text'" class="col-lg-12">
                      <div class="form-group">
                        <label class="form-label">
                          {{ 'Levels_Array.Level_textContent' | translate }}<span>*</span>
                          <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_textContent_tooltip' | translate }}"
                            nzTooltipPlacement="top">
                            <i class="fa-solid fa-circle-info info"></i>
                          </span>
                        </label>
                        <div class="row">
                          <!-- Loop through textContent FormArray -->
                          <div *ngFor="let textControl of getTextContents(i).controls; let j = index"
                            class="mb-2 col-lg-6">
                            <div class="d-flex gap-2 align-items-start">
                              <div class="flex-grow-1">
                                <input [id]="'textContent_' + i + '_' + j" class="form-control"
                                  [formControl]="$any(textControl)"
                                  [placeholder]="'Levels_Array.Level_textContent_placeholder' | translate"
                                  maxlength="1000" />

                                <!-- Character counter -->
                                <!-- <div class="character-counter">
                                  <small [ngClass]="{
                                  'text-danger': (textControl.value?.length || 0) === 1000,
                                  'text-dark': (textControl.value?.length || 0) < 1000
                                }">
                                    {{ textControl.value?.length || 0 }}/1000
                                  </small>
                                </div> -->

                                <small class="error text-danger"
                                  *ngIf="!isSavingDraft && textControl?.invalid && textControl?.touched">
                                  {{ 'Levels_Array.Level_textContent_required' | translate }}
                                </small>
                              </div>

                              <!-- Remove button (only show if more than one text field) -->
                              <button type="button" class="btn btn-trash" *ngIf="getTextContents(i).length > 1"
                                (click)="removeTextContent(i, j)" style="margin-top: 0;">
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- Add Text button -->
                        <button type="button" class="btn btn-sm btn-primary mt-2" (click)="addTextContent(i)"
                          [disabled]="getAcceptAnyAnswerControl(i).value"
                          [ngClass]="{'cursor-not-allowed': getAcceptAnyAnswerControl(i).value}">
                          <i class="fa fa-plus"></i> Add Answer
                        </button>
                        <div class="form-check mt-3">
                          <input class="form-check-input" type="checkbox" [formControl]="getAcceptAnyAnswerControl(i)"
                            [id]="'accept-any-' + i">
                          <label class="form-check-label" [attr.for]="'accept-any-' + i">
                            Accept any answer
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- QR Code Type -->
                    <div *ngIf="level.get('type')?.value === 'qr'" class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'qrData_' + i" class="form-label">
                          Qr Code<span>*</span>
                          <span class="label_subtext px-2">
                            <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_qrData_tooltip' | translate">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <div class="position-relative">
                          <input type="text" [id]="'qrData_' + i" class="form-control" formControlName="qrData"
                            placeholder="Add QR Content" style="padding-right: 120px;" />
                          <button type="button" class="btn btn-dark position-absolute" (click)="generateQrCode(i)"
                            [disabled]="isQrGenerateDisabled(i)"
                            [ngClass]="{'cursor-not-allowed': isQrGenerateDisabled(i)}"
                            style="top: 50%; right: 5px; transform: translateY(-50%); font-size:14px; padding: 4px 9px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                              fill="none" style="margin-right: 8px; vertical-align: middle;">
                              <rect x="3" y="3" width="8" height="8" rx="1" stroke="white" stroke-width="2" />
                              <rect x="13" y="3" width="8" height="8" rx="1" stroke="white" stroke-width="2" />
                              <rect x="3" y="13" width="8" height="8" rx="1" stroke="white" stroke-width="2" />
                              <rect x="13" y="13" width="3" height="3" fill="white" />
                              <rect x="18" y="13" width="3" height="3" fill="white" />
                              <rect x="13" y="18" width="3" height="3" fill="white" />
                              <rect x="18" y="18" width="3" height="3" fill="white" />
                            </svg>
                            {{ levelQrCodes[i] && !hasQrInputChanged(i) ? 'Preview' : 'Generate' }}
                          </button>
                        </div>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('qrData')?.touched && level.get('qrData')?.errors?.['required']">
                          {{ 'Levels_Array.Level_qrData_required' | translate }}
                        </small>
                      </div>
                    </div>

                    <!-- QR Modal -->
                    <div class="qr-modal">

                      <nz-modal [(nzVisible)]="isQrVisible" [nzFooter]="null" nzWidth="389px" style="border-radius:20px"
                        (nzOnCancel)="handleQRCancel()" [nzClassName]="'QRMODAL'">
                        <div class="d-flex justify-content-center" style="flex-direction: column; align-items: center;">
                          <ng-container *nzModalContent>
                            <div class="qr-code-container" #qrWrapper>
                              <qrcode #qrcode [qrdata]="levelQrCodes[i] || ''" [width]="300"
                                [errorCorrectionLevel]="'M'" [allowEmptyString]="true">
                              </qrcode>
                            </div>
                            <button class="btn btn-primary w-100" (click)="onDownloadQR(qrWrapper)">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28"
                                fill="none" class="me-2">
                                <path
                                  d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                                <path
                                  d="M15.5 10.5C15.5 10.5 12.9223 14 12 14C11.0777 14 8.5 10.5 8.5 10.5M12 13.5V6.99997M8.5 17H15.5"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                              </svg>
                              {{ 'Levels_Array.Level_qr_download_btn' | translate }}
                            </button>
                          </ng-container>
                        </div>
                      </nz-modal>
                    </div>

                    <!-- Image Type -->
                    <ng-container *ngIf="level.get('type')?.value === 'image'">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label class="form-label">
                            {{ 'Levels_Array.Level_image' | translate }}
                            <span>*</span>
                            <span class="label_subtext">
                              <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_image_tooltip' | translate">
                                <i class="fa-solid fa-circle-info"></i>
                              </span>
                            </span>
                          </label>
                          <div class="position-relative image-upload-field">
                            <input type="text" [id]="'imageDisplay_' + i" class="form-control"
                              [value]="levelImagePreviews[i] ? 'Image' : ''" placeholder="Upload Image" readonly
                              style="padding-right: 210px; cursor: pointer;"
                              (click)="levelImagePreviews[i] ? showImageModal(i) : triggerLevelImageInput(i)" />
                            <input type="file" [id]="'imageFile_' + i" class="form-control d-none"
                              accept=".png, .jpg, .jpeg" (change)="onLevelImageSelected($event, i)" #imageInput />
                            <!-- AI Regenerate button -->
                            <button *ngIf="hasAiAccess" type="button" class="btn btn-dark position-absolute"
                              (click)="openAiRegenModal($event, 'level', i)"
                              style="top: 50%; right: 5px; transform: translateY(-50%); font-size:14px; padding: 4px 9px; background:#5304FB; border-color:#5304FB;">
                              <i class="fa-solid fa-wand-magic-sparkles" style="margin-right:4px;"></i>
                              AI
                            </button>
                            <button type="button" class="btn btn-dark position-absolute"
                              (click)="levelImagePreviews[i] ? showImageModal(i) : triggerLevelImageInput(i)"
                              style="top: 50%; right: 100px; transform: translateY(-50%); font-size:14px; padding: 4px 9px;">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_40000187_7685" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                  y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_40000187_7685)">
                                  <path
                                    d="M18 15.75C18 17.4833 17.3917 18.9583 16.175 20.175C14.9583 21.3917 13.4833 22 11.75 22C10.0167 22 8.54167 21.3917 7.325 20.175C6.10833 18.9583 5.5 17.4833 5.5 15.75V6.5C5.5 5.25 5.9375 4.1875 6.8125 3.3125C7.6875 2.4375 8.75 2 10 2C11.25 2 12.3125 2.4375 13.1875 3.3125C14.0625 4.1875 14.5 5.25 14.5 6.5V15.25C14.5 16.0167 14.2333 16.6667 13.7 17.2C13.1667 17.7333 12.5167 18 11.75 18C10.9833 18 10.3333 17.7333 9.8 17.2C9.26667 16.6667 9 16.0167 9 15.25V6H11V15.25C11 15.4667 11.0708 15.6458 11.2125 15.7875C11.3542 15.9292 11.5333 16 11.75 16C11.9667 16 12.1458 15.9292 12.2875 15.7875C12.4292 15.6458 12.5 15.4667 12.5 15.25V6.5C12.4833 5.8 12.2375 5.20833 11.7625 4.725C11.2875 4.24167 10.7 4 10 4C9.3 4 8.70833 4.24167 8.225 4.725C7.74167 5.20833 7.5 5.8 7.5 6.5V15.75C7.48333 16.9333 7.89167 17.9375 8.725 18.7625C9.55833 19.5875 10.5667 20 11.75 20C12.9167 20 13.9083 19.5875 14.725 18.7625C15.5417 17.9375 15.9667 16.9333 16 15.75V6H18V15.75Z"
                                    fill="white" />
                                </g>
                              </svg>

                              {{ levelImagePreviews[i] ? 'preview' : 'Upload' }}
                            </button>
                          </div>
                          <small class="error text-danger"
                            *ngIf="!isSavingDraft && level.get('imageFile')?.invalid && level.get('imageFile')?.touched && !levelImagePreviews[i]">
                            {{ 'Levels_Array.Level_image_required' | translate }}
                          </small>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Image Preview Modal -->
                    <nz-modal [(nzVisible)]="isImageVisible[i]" [nzTitle]="'Image Preview'"
                      (nzOnCancel)="handleImageCancel(i)" [nzClassName]="'ImageModal'" (nzOnOk)="handleImageOk(i)"
                      [nzWidth]="600">
                      <div class="d-flex justify-content-center" style="flex-direction: column; align-items: center;">
                        <ng-container *nzModalContent>
                          <div class="mb-3 image-preview-container">
                            <img [src]="levelImagePreviews[i]" alt="Level Image"
                              style="max-width: 100%; max-height: 500px; border-radius: 8px;" />
                          </div>
                          <div class="d-flex gap-2">
                            <button class="btn btn-primary flex-fill" (click)="triggerLevelImageInput(i)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" style="margin-right: 8px; vertical-align: middle;">
                                <path
                                  d="M14 3.5H10C6.22876 3.5 4.34315 3.5 3.17157 4.67157C2 5.84315 2 7.72876 2 11.5V13.5C2 17.2712 2 19.1569 3.17157 20.3284C4.34315 21.5 6.22876 21.5 10 21.5H14C17.7712 21.5 19.6569 21.5 20.8284 20.3284C22 19.1569 22 17.2712 22 13.5V11.5C22 7.72876 22 5.84315 20.8284 4.67157C19.6569 3.5 17.7712 3.5 14 3.5Z"
                                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M8.5 10.5C9.32843 10.5 10 9.82843 10 9C10 8.17157 9.32843 7.5 8.5 7.5C7.67157 7.5 7 8.17157 7 9C7 9.82843 7.67157 10.5 8.5 10.5Z"
                                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M21.5 17.5L16.348 11.8797C16.1263 11.6377 15.8131 11.5 15.485 11.5C15.1744 11.5 14.8766 11.6234 14.6571 11.8429L10 16.5L7.83928 14.3393C7.62204 14.122 7.32741 14 7.02019 14C6.68931 14 6.37423 14.1415 6.15441 14.3888L2.5 18.5"
                                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              Replace Image
                            </button>
                            <button class="btn btn-success flex-fill" (click)="handleImageOk(i)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" style="margin-right: 8px; vertical-align: middle;">
                                <path d="M5 13L9 17L19 7" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                              Save Image
                            </button>
                          </div>
                        </ng-container>
                      </div>
                    </nz-modal>

                    <!-- Quiz Type -->
                    <div *ngIf="level.get('type')?.value === 'quiz'" class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'quizzes_id_' + i" class="form-label">
                          {{ 'Levels_Array.Level_quiz' | translate }}
                          <span>*</span>
                          <span class="label_subtext px-2">
                            <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_quiz_tooltip' | translate">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <nz-select nzShowSearch nzAllowClear
                          [nzPlaceHolder]="'Levels_Array.Level_quiz_placeholder' | translate" class="form-control-qr"
                          formControlName="quizzes_id" (nzOpenChange)="onQuizDropdownOpen($event)">
                          <nz-option *ngFor="let quiz of quizzesList" [nzLabel]="quiz.quiz_title"
                            [nzValue]="quiz.id"></nz-option>
                        </nz-select>
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('quizzes_id')?.invalid && level.get('quizzes_id')?.touched">
                          {{ 'Levels_Array.Level_quiz_required' | translate }}
                        </small>
                      </div>
                    </div>

                    <!-- ── Survey Level ───────────────────────────────────────── -->
                    <div *ngIf="level.get('type')?.value === 'survey'" class="col-lg-12">
                      <div class="survey-builder">

                        <!-- Survey Settings Row -->
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label class="form-label">
                                {{ 'add-content.min-answers' | translate }} <span>*</span>
                                <span nz-tooltip [nzTooltipTitle]="'add-content.min-answers-tooltip' | translate">
                                  <i class="fa-solid fa-circle-info info ms-1"></i>
                                </span>
                              </label>
                              <input type="number" class="form-control" formControlName="min_answers_required"
                                [min]="globalLevelSettings?.survey_min_answers || 1"
                                [placeholder]="'add-content.min-answers-placeholder' | translate" />
                              <small class="text-muted mt-1 d-block">
                                Minimum {{ globalLevelSettings?.survey_min_answers || 1 }} answer{{ (globalLevelSettings?.survey_min_answers || 1) > 1 ? 's' : '' }} required
                              </small>
                              <div *ngIf="level.get('min_answers_required')?.errors?.['min'] && level.get('min_answers_required')?.touched" class="text-danger mt-1" style="font-size:12px;">
                                Value cannot be less than {{ globalLevelSettings?.survey_min_answers || 1 }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label class="form-label">{{ 'add-content.question-order' | translate }}</label>
                              <div class="select-options">
                                <a href="javascript:void(0)" class="option"
                                  [class.active]="level.get('question_order')?.value === 'fixed'"
                                  (click)="level.get('question_order')?.setValue('fixed')">
                                  {{ 'add-content.order-fixed' | translate }}
                                </a>
                                <a href="javascript:void(0)" class="option"
                                  [class.active]="level.get('question_order')?.value === 'randomized'"
                                  (click)="level.get('question_order')?.setValue('randomized')">
                                  {{ 'add-content.order-randomized' | translate }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Questions -->
                        <div formArrayName="survey_questions">
                          <div *ngFor="let question of getSurveyQuestions(i).controls; let qi = index"
                            [formGroupName]="qi" class="survey-question-card mb-3 p-3"
                            style="border:1px solid #e2e8f0; border-radius:10px; background:#fafbff;">

                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <span class="fw-semibold" style="font-size:14px;">
                                {{ 'add-content.question' | translate }} {{ qi + 1 }}
                              </span>
                              <button type="button" class="btn btn-sm btn-outline-danger"
                                *ngIf="getSurveyQuestions(i).length > 1"
                                (click)="removeSurveyQuestion(i, qi)">
                                <i class="fa-solid fa-trash-can"></i>
                              </button>
                            </div>

                            <div class="row">
                              <!-- Question Text -->
                              <div class="col-lg-8">
                                <div class="form-group">
                                  <label class="form-label">{{ 'add-content.question-text' | translate }} <span>*</span></label>
                                  <input type="text" class="form-control" formControlName="question_text"
                                    [placeholder]="'add-content.question-text-placeholder' | translate" />
                                  <small class="error text-danger"
                                    *ngIf="!isSavingDraft && question.get('question_text')?.invalid && question.get('question_text')?.touched">
                                    {{ 'add-content.question-text-required' | translate }}
                                  </small>
                                </div>
                              </div>

                              <!-- Question Type -->
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label class="form-label">{{ 'add-content.question-type' | translate }}</label>
                                  <div class="select-options">
                                    <a href="javascript:void(0)" class="option"
                                      [class.active]="question.get('question_type')?.value === 'mcq'"
                                      (click)="onSurveyQuestionTypeChange(i, qi, 'mcq')">
                                      {{ 'add-content.mcq' | translate }}
                                    </a>
                                    <a href="javascript:void(0)" class="option"
                                      [class.active]="question.get('question_type')?.value === 'open_text'"
                                      (click)="onSurveyQuestionTypeChange(i, qi, 'open_text')">
                                      {{ 'add-content.open-text' | translate }}
                                    </a>
                                  </div>
                                </div>
                              </div>

                              <!-- Required Toggle -->
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <label class="form-label">{{ 'add-content.required' | translate }}</label>
                                  <div class="select-options">
                                    <a href="javascript:void(0)" class="option"
                                      [class.active]="question.get('is_required')?.value === true"
                                      (click)="question.get('is_required')?.setValue(true)">
                                      {{ 'add-content.required-yes' | translate }}
                                    </a>
                                    <a href="javascript:void(0)" class="option"
                                      [class.active]="question.get('is_required')?.value === false"
                                      (click)="question.get('is_required')?.setValue(false)">
                                      {{ 'add-content.required-no' | translate }}
                                    </a>
                                  </div>
                                </div>
                              </div>

                              <!-- MCQ Options -->
                              <div class="col-lg-12" *ngIf="question.get('question_type')?.value === 'mcq'">
                                <div class="form-group">
                                  <label class="form-label">
                                    {{ 'add-content.answer-options' | translate }}
                                    <span class="text-muted ms-1" style="font-size:12px;">(2–6)</span>
                                  </label>
                                  <div formArrayName="options">
                                    <div *ngFor="let opt of getSurveyOptions(i, qi).controls; let oi = index"
                                      class="d-flex gap-2 mb-2 align-items-center">
                                      <input type="text" class="form-control" [formControlName]="oi"
                                        [placeholder]="('add-content.option' | translate) + ' ' + (oi + 1)" />
                                      <button type="button" class="btn btn-sm btn-outline-danger"
                                        *ngIf="getSurveyOptions(i, qi).length > 2"
                                        (click)="removeSurveyOption(i, qi, oi)">
                                        <i class="fa-solid fa-xmark"></i>
                                      </button>
                                    </div>
                                  </div>
                                  <button type="button" class="btn btn-sm btn-outline-primary mt-1"
                                    *ngIf="getSurveyOptions(i, qi).length < 6"
                                    (click)="addSurveyOption(i, qi)">
                                    <i class="fa-solid fa-plus me-1"></i>
                                    {{ 'add-content.add-option' | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Add Question Button -->
                        <button type="button" class="btn btn-outline-primary mt-2"
                          (click)="addSurveyQuestion(i)">
                          <i class="fa-solid fa-plus me-1"></i>
                          {{ 'add-content.add-question' | translate }}
                        </button>
                      </div>
                    </div>

                    <!-- ── Link Task Level ─────────────────────────────────────── -->
                    <div *ngIf="level.get('type')?.value === 'link_task'" class="col-lg-12">
                      <div class="row">
                        <!-- Task Instruction -->
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label class="form-label">
                              {{ 'add-content.task-instruction' | translate }} <span>*</span>
                              <span nz-tooltip [nzTooltipTitle]="'add-content.task-instruction-tooltip' | translate">
                                <i class="fa-solid fa-circle-info info ms-1"></i>
                              </span>
                            </label>
                            <input type="text" class="form-control" formControlName="link_task_instruction"
                              [placeholder]="'add-content.task-instruction-placeholder' | translate" />
                            <small class="error text-danger"
                              *ngIf="!isSavingDraft && level.get('link_task_instruction')?.invalid && level.get('link_task_instruction')?.touched">
                              {{ 'add-content.task-instruction-required' | translate }}
                            </small>
                          </div>
                        </div>

                        <!-- URL -->
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label class="form-label">
                              {{ 'add-content.task-url' | translate }} <span>*</span>
                              <span nz-tooltip [nzTooltipTitle]="'add-content.task-url-tooltip' | translate">
                                <i class="fa-solid fa-circle-info info ms-1"></i>
                              </span>
                            </label>
                            <input type="url" class="form-control" formControlName="link_task_url"
                              placeholder="https://..." />
                            <small class="error text-danger"
                              *ngIf="!isSavingDraft && level.get('link_task_url')?.invalid && level.get('link_task_url')?.touched">
                              {{ 'add-content.task-url-required' | translate }}
                            </small>
                          </div>
                        </div>

                        <!-- Timer Duration -->
                        <div class="col-lg-4">
                          <div class="form-group">
                            <label class="form-label">
                              {{ 'add-content.timer-duration' | translate }} <span>*</span>
                              <span nz-tooltip [nzTooltipTitle]="'add-content.timer-duration-tooltip' | translate">
                                <i class="fa-solid fa-circle-info info ms-1"></i>
                              </span>
                            </label>
                            <input type="number" class="form-control" formControlName="link_task_timer"
                              [min]="globalLevelSettings?.link_task_min_timer || 10"
                              [max]="globalLevelSettings?.link_task_max_timer"
                              [placeholder]="'add-content.timer-placeholder' | translate" />
                            <small *ngIf="globalLevelSettings?.link_task_min_timer" class="text-muted mt-1 d-block">
                              Min: {{ globalLevelSettings.link_task_min_timer }}s, Max: {{ globalLevelSettings.link_task_max_timer }}s
                            </small>
                            <div *ngIf="level.get('link_task_timer')?.errors?.['min'] && level.get('link_task_timer')?.touched" class="text-danger mt-1" style="font-size:12px;">
                              Value cannot be less than {{ globalLevelSettings?.link_task_min_timer || 10 }}
                            </div>
                            <div *ngIf="level.get('link_task_timer')?.errors?.['max'] && level.get('link_task_timer')?.touched" class="text-danger mt-1" style="font-size:12px;">
                              Value cannot exceed {{ globalLevelSettings?.link_task_max_timer }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Client Webhook -->
                    <div *ngIf="level.get('type')?.value === 'client_webhook'" class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'client_' + i" class="form-label">
                          {{ 'Levels_Array.Level_clientWebhook' | translate }}
                          <span>*</span>
                          <span class="label_subtext px-2">
                            <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_clientWebhook_tooltip' | translate">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <input type="text" [id]="'client_' + i" class="form-control"
                          formControlName="client_webhook_url"
                          [placeholder]="'Levels_Array.Level_clientWebhook_placeholder' | translate" />
                        <small class="error text-danger"
                          *ngIf="!isSavingDraft && level.get('client_webhook_url')?.invalid && level.get('client_webhook_url')?.touched">
                          <span *ngIf="level.get('client_webhook_url')?.errors?.['required']">
                            {{ 'Levels_Array.Level_clientWebhook_required' | translate }}
                          </span>
                          <span *ngIf="level.get('client_webhook_url')?.errors?.['pattern']">
                            {{ 'Levels_Array.Level_clientWebhook_invalid' | translate }}
                          </span>
                        </small>
                      </div>
                    </div>

                    <!-- Luqta Webhook Site URL -->
                    <div *ngIf="level.get('type')?.value === 'luqta_weebhook'" class="col-lg-6">
                      <div class="form-group">
                        <label [for]="'luqta_' + i" class="form-label">
                          Luqta Webhook Site URL
                          <span class="label_subtext">
                            <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_luqtaWebhook_tooltip' | translate">
                              <i class="fa-solid fa-circle-info"></i>
                            </span>
                          </span>
                        </label>
                        <input type="text" [id]="'luqta_' + i" class="form-control"
                          formControlName="luqta_webhook_url" placeholder="https://..." />
                      </div>
                    </div>

                    <!-- Client Variables (for Client Webhook) -->
                    <div class="col-12" formArrayName="client_variables"
                      *ngIf="level.get('type')?.value === 'client_webhook'">
                      <button type="button" class="btn btn-dark mb-3" (click)="addSubItem(i)">
                        {{ 'Levels_Array.Level_addVariable' | translate }}
                      </button>
                      <small class="error text-danger d-block mb-2"
                        *ngIf="!isSavingDraft && level.errors?.['clientVariablesRequired']">
                        At least one variable is required for Client Webhook.
                      </small>
                      <small class="error text-danger d-block mb-2"
                        *ngIf="!isSavingDraft && level.errors?.['clientVariablesIncomplete']">
                        Fill Variable Name, Display Name, and Data Type for each variable.
                      </small>
                      <div *ngIf="subItems(i)?.length">
                        <div *ngFor="let sub of subItems(i).controls; let j = index" [formGroupName]="j"
                          class="form-row">
                          <div class="row">
                            <div class="col-lg-11">
                              <div class="d-flex form-group align-items-start gap-3 mb-2">
                                <div class="flex-grow-1">
                                  <label class="form-label d-flex align-items-center gap-1">
                                    {{ 'Levels_Array.Level_variableName' | translate }}
                                    <span nz-tooltip
                                      nzTooltipTitle="{{ 'Levels_Array.Level_variableName_tooltip' | translate }}"
                                      nzTooltipPlacement="top">
                                      <i class="fa-solid fa-circle-info info" style="font-size: 12px;"></i>
                                    </span>
                                  </label>
                                  <input class="form-control" formControlName="variable_name"
                                    [placeholder]="'Levels_Array.Level_variableName' | translate" />
                                </div>
                                <div class="flex-grow-1">
                                  <label class="form-label d-flex align-items-center gap-1">
                                    {{ 'Levels_Array.Level_displayName' | translate }}
                                    <span nz-tooltip
                                      nzTooltipTitle="{{ 'Levels_Array.Level_displayName_tooltip' | translate }}"
                                      nzTooltipPlacement="top">
                                      <i class="fa-solid fa-circle-info info" style="font-size: 12px;"></i>
                                    </span>
                                  </label>
                                  <input class="form-control" formControlName="display_name"
                                    [placeholder]="'Levels_Array.Level_displayName' | translate" />
                                </div>
                                <div class="flex-grow-1">
                                  <label class="form-label d-flex align-items-center gap-1">
                                    {{ 'Levels_Array.Level_datatype' | translate }}
                                    <span nz-tooltip
                                      nzTooltipTitle="{{ 'Levels_Array.Level_datatype_tooltip' | translate }}"
                                      nzTooltipPlacement="top">
                                      <i class="fa-solid fa-circle-info info" style="font-size: 12px;"></i>
                                    </span>
                                  </label>
                                  <nz-select class="form-control-qr" formControlName="datatype"
                                    [nzPlaceHolder]="'Levels_Array.Level_selectDatatype' | translate" nzSize="large">
                                    <nz-option nzValue="string"
                                      [nzLabel]="'Levels_Array.Datatype_string' | translate"></nz-option>
                                    <nz-option nzValue="number"
                                      [nzLabel]="'Levels_Array.Datatype_number' | translate"></nz-option>
                                    <nz-option nzValue="boolean"
                                      [nzLabel]="'Levels_Array.Datatype_boolean' | translate"></nz-option>
                                    <nz-option nzValue="date"
                                      [nzLabel]="'Levels_Array.Datatype_date' | translate"></nz-option>
                                    <nz-option nzValue="datetime"
                                      [nzLabel]="'Levels_Array.Datatype_datetime' | translate"></nz-option>
                                    <nz-option nzValue="float"
                                      [nzLabel]="'Levels_Array.Datatype_float' | translate"></nz-option>
                                    <nz-option nzValue="double"
                                      [nzLabel]="'Levels_Array.Datatype_double' | translate"></nz-option>
                                  </nz-select>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-1">
                              <div
                                class="d-flex form-group justify-content-center align-items-center h-100 gap-3 mb-2 mt-2">
                                <button type="button" class="btn btn-trash" (click)="deleteSubItem(i, j)">
                                  <i class="fa -solid fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- End Step 3 -->

          <!-- Action Buttons -->
          <div class="action-button">
            <button type="button" class="btn btn-primary" *ngIf="currentStep > 1"
              (click)="previousStep()">Previous</button>
            <button type="button" class="btn btn-primary" *ngIf="currentStep < 3" (click)="nextStep()">Next</button>

            <!-- Submit/Update Button - Show on step 3 or on any step in edit mode -->
            <button type="button" class="btn btn-primary" *ngIf="currentStep === 3 || isEditMode"
              [disabled]="contestLimitReached || isSubmitting"
              [nz-tooltip]="contestLimitReached ? 'Engagement limit reached. Upgrade your plan to create more engagements.' : ''"
              (click)="onSubmit(false)">{{ isEditMode ? 'Update' : 'Submit' }}</button>

            <!-- Save as draft:
                 - always available in create mode
                 - available in edit mode only for contests already in draft status -->
            <button type="button" class="btn btn-primary-outline"
              *ngIf="!isEditMode || (isEditMode && singleContestData?.status === 'draft')"
              [disabled]="isSubmitting" (click)="confirmSaveAsDraft()">
              Save as draft
            </button>
          </div>

        </div>
        <div class="col-lg-4">
          <div class="luqta-review-card">
            <h3 class="heading">
              Review
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14 21H16M14 21C13.1716 21 12.5 20.3284 12.5 19.5V17H12M14 21H10M12 17H11.5V19.5C11.5 20.3284 10.8284 21 10 21M12 17V21M10 21H8"
                  stroke="url(#paint0_linear_40000187_6385)" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M16 3H8C5.17157 3 3.75736 3 2.87868 3.87868C2 4.75736 2 6.17157 2 9V11C2 13.8284 2 15.2426 2.87868 16.1213C3.75736 17 5.17157 17 8 17H16C18.8284 17 20.2426 17 21.1213 16.1213C22 15.2426 22 13.8284 22 11V9C22 6.17157 22 4.75736 21.1213 3.87868C20.2426 3 18.8284 3 16 3Z"
                  stroke="url(#paint1_linear_40000187_6385)" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M14.576 9.235L11.189 7.11812C11.0655 7.04093 10.9228 7 10.7771 7C10.3479 7 10 7.34793 10 7.77712V12.2229C10 12.6521 10.3479 13 10.7771 13C10.9228 13 11.0655 12.9591 11.189 12.8819L14.576 10.765C14.8398 10.6001 15 10.311 15 10C15 9.68896 14.8398 9.39985 14.576 9.235Z"
                  stroke="url(#paint2_linear_40000187_6385)" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <defs>
                  <linearGradient id="paint0_linear_40000187_6385" x1="5.38875" y1="24.3636" x2="13.0751" y2="16.4714"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.14" stop-color="#8F67FD" />
                    <stop offset="1" stop-color="#5304FB" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_40000187_6385" x1="-4.52813" y1="28.7724" x2="21.1398" y2="9.94737"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.14" stop-color="#8F67FD" />
                    <stop offset="1" stop-color="#5304FB" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_40000187_6385" x1="8.36797" y1="18.0453" x2="16.7098" y2="14.4765"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.14" stop-color="#8F67FD" />
                    <stop offset="1" stop-color="#5304FB" />
                  </linearGradient>
                </defs>
              </svg>

            </h3>
            <ng-container *ngIf="bannerPreviews && bannerPreviews.length > 0; else defaultBanner">
              <div class="review-card-box">
                <div class="review-card">
                  <div class="banner">
                    <div class="banner-slider-track"
                      [style.transform]="'translateX(-' + (activeBannerIndex * 100) + '%)'">
                      <img *ngFor="let img of bannerPreviews" [src]="img" alt="" />
                    </div>

                    <!-- Remove Icon -->
                    <button class="remove-icon" (click)="removeBanner(activeBannerIndex)" type="button">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>

                    <!-- Banner Navigation Arrows -->
                    <button *ngIf="activeBannerIndex > 0" class="banner-nav banner-nav-prev"
                      (click)="prevBanner($event)">
                      <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <button *ngIf="activeBannerIndex < bannerPreviews.length - 1" class="banner-nav banner-nav-next"
                      (click)="nextBanner($event)">
                      <i class="fa-solid fa-chevron-right"></i>
                    </button>
                    <div class="banner-dots" *ngIf="bannerPreviews.length > 1">
                      <span *ngFor="let img of bannerPreviews; let i = index" class="dot"
                        [class.active]="i === activeBannerIndex" (click)="goToBanner(i, $event)"></span>
                    </div>

                    <div class="logo">
                      <img [src]="clientLogo" alt="Client Logo">
                    </div>
                    <div class="card-content">
                      <div class="badges-row">
                        <div class="badge">
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_40000187_6396" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                              y="0" width="15" height="15">
                              <rect width="14.53" height="14.53" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_40000187_6396)">
                              <path
                                d="M9.02402 11.8059C7.75577 11.8059 6.6815 11.3657 5.80123 10.4855C4.92105 9.60529 4.48096 8.53102 4.48096 7.26267C4.48096 6.00391 4.92105 4.93287 5.80123 4.04957C6.6815 3.16626 7.75577 2.72461 9.02402 2.72461C10.2829 2.72461 11.3539 3.16626 12.2371 4.04957C13.1204 4.93287 13.5621 6.00391 13.5621 7.26267C13.5621 8.53102 13.1204 9.60529 12.2371 10.4855C11.3539 11.3657 10.2829 11.8059 9.02402 11.8059ZM9.02145 10.8978C10.0305 10.8978 10.8882 10.5446 11.5945 9.83827C12.3008 9.13195 12.654 8.27428 12.654 7.26525C12.654 6.25622 12.3008 5.39854 11.5945 4.69222C10.8882 3.9859 10.0305 3.63274 9.02145 3.63274C8.01242 3.63274 7.15474 3.9859 6.44842 4.69222C5.7421 5.39854 5.38894 6.25622 5.38894 7.26525C5.38894 8.27428 5.7421 9.13195 6.44842 9.83827C7.15474 10.5446 8.01242 10.8978 9.02145 10.8978ZM10.457 9.36317L11.1044 8.71598L9.47551 7.0871V4.93666H8.56738V7.45853L10.457 9.36317ZM1.57026 5.29764V4.38951H3.87554V5.29764H1.57026ZM0.964844 7.71931V6.81118H3.87554V7.71931H0.964844ZM1.57026 10.141V9.23285H3.87554V10.141H1.57026Z"
                                fill="#1C1B1F" />
                            </g>
                          </svg>
                          <span>{{ contestTimeLeft }}</span>
                        </div>
                        <div class="badge">
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_40000187_6401" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                              y="0" width="15" height="15">
                              <rect width="14.53" height="14.53" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_40000187_6401)">
                              <path
                                d="M4.05513 13.622V9.02676L2.03516 5.7516L4.6489 1.51367H9.88819L12.5019 5.7516L10.482 9.02676V13.622L7.26854 12.5335L4.05513 13.622ZM4.96326 12.3378L7.26854 11.5706L9.57382 12.3378V9.98952H4.96326V12.3378ZM5.15533 2.4218L3.09691 5.7516L5.15533 9.0814H9.38175L11.4402 5.7516L9.38175 2.4218H5.15533ZM6.63285 8.0033L4.699 6.08458L5.34634 5.43723L6.63285 6.72375L9.19075 4.15072L9.83809 4.78293L6.63285 8.0033Z"
                                fill="#1C1B1F" />
                            </g>
                          </svg>
                          <span>Levels ({{ levels.length }})</span>
                        </div>
                      </div>
                      <div class="content">
                        <div class="preview-text">
                          <h5 class="preview-title">{{ addContentForm.get('name')?.value || 'Engagement name' }}</h5>
                          <p class="preview-description">{{addContentForm.get('details')?.value || 'Descriptions'}}</p>
                        </div>
                        <button class="btn btn-join">
                          Join
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Default Banner Template -->
            <ng-template #defaultBanner>
              <div class="review-card">
                <div class="banner banner-placeholder">
                  <div class="placeholder-content">
                    <img [src]="clientLogo" alt="Client Logo" class="placeholder-logo">
                    <span class="placeholder-text">Engagement Banner</span>
                  </div>

                  <div class="logo">
                    <img [src]="clientLogo" alt="Client Logo">
                  </div>

                  <div class="card-content">
                    <div class="badges-row">
                      <div class="badge">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_40000187_6396" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="15" height="15">
                            <rect width="14.53" height="14.53" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_40000187_6396)">
                            <path
                              d="M9.02402 11.8059C7.75577 11.8059 6.6815 11.3657 5.80123 10.4855C4.92105 9.60529 4.48096 8.53102 4.48096 7.26267C4.48096 6.00391 4.92105 4.93287 5.80123 4.04957C6.6815 3.16626 7.75577 2.72461 9.02402 2.72461C10.2829 2.72461 11.3539 3.16626 12.2371 4.04957C13.1204 4.93287 13.5621 6.00391 13.5621 7.26267C13.5621 8.53102 13.1204 9.60529 12.2371 10.4855C11.3539 11.3657 10.2829 11.8059 9.02402 11.8059ZM9.02145 10.8978C10.0305 10.8978 10.8882 10.5446 11.5945 9.83827C12.3008 9.13195 12.654 8.27428 12.654 7.26525C12.654 6.25622 12.3008 5.39854 11.5945 4.69222C10.8882 3.9859 10.0305 3.63274 9.02145 3.63274C8.01242 3.63274 7.15474 3.9859 6.44842 4.69222C5.7421 5.39854 5.38894 6.25622 5.38894 7.26525C5.38894 8.27428 5.7421 9.13195 6.44842 9.83827C7.15474 10.5446 8.01242 10.8978 9.02145 10.8978ZM10.457 9.36317L11.1044 8.71598L9.47551 7.0871V4.93666H8.56738V7.45853L10.457 9.36317ZM1.57026 5.29764V4.38951H3.87554V5.29764H1.57026ZM0.964844 7.71931V6.81118H3.87554V7.71931H0.964844ZM1.57026 10.141V9.23285H3.87554V10.141H1.57026Z"
                              fill="#1C1B1F" />
                          </g>
                        </svg>
                        <span>{{ contestTimeLeft }}</span>
                      </div>
                      <div class="badge">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_40000187_6401" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="15" height="15">
                            <rect width="14.53" height="14.53" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_40000187_6401)">
                            <path
                              d="M4.05513 13.622V9.02676L2.03516 5.7516L4.6489 1.51367H9.88819L12.5019 5.7516L10.482 9.02676V13.622L7.26854 12.5335L4.05513 13.622ZM4.96326 12.3378L7.26854 11.5706L9.57382 12.3378V9.98952H4.96326V12.3378ZM5.15533 2.4218L3.09691 5.7516L5.15533 9.0814H9.38175L11.4402 5.7516L9.38175 2.4218H5.15533ZM6.63285 8.0033L4.699 6.08458L5.34634 5.43723L6.63285 6.72375L9.19075 4.15072L9.83809 4.78293L6.63285 8.0033Z"
                              fill="#1C1B1F" />
                          </g>
                        </svg>
                        <span>Levels</span>
                      </div>
                    </div>
                    <div class="content">
                      <div class="preview-text">
                        <h5 class="preview-title">{{ addContentForm.get('name')?.value || 'Engagement name' }}</h5>
                        <p class="preview-description">{{addContentForm.get('details')?.value || 'Descriptions'}}</p>
                      </div>
                      <button class="btn btn-join">
                        Join
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="detail">
              <h5>
                {{ addContentForm.get('name')?.value || 'Engagement name' }}
              </h5>

              <p>{{addContentForm.get('details')?.value || 'Descriptions'}}</p>
            </div>
            <div class="detail">
              <h5>
                Durations
              </h5>
              <p>
                <ng-container
                  *ngIf="addContentForm.controls['start_date'].value && addContentForm.controls['end_date'].value; else noDates">
                  {{ addContentForm.controls['start_date'].value | date: 'MM/d/yyyy' }}
                  to
                  {{ addContentForm.controls['end_date'].value | date: 'MM/d/yyyy' }}
                </ng-container>
                <ng-template #noDates>00/00/0000 to 00/00/0000</ng-template>
              </p>
            </div>
          </div>
          <!-- ------levels------ -->
          <div class="luqta-review-card" *ngIf="currentStep === 3">
            <div class="detail">
              <h5>Levels</h5>
            </div>

            <!-- Levels List -->
            <div class="levels-list" *ngIf="levels.length > 0; else noLevels">
              <div class="level-item" *ngFor="let level of levels.controls; let i = index">
                <div class="level-icon">
                  <img src="/assets/images/level-image.png" alt="">
                </div>
                <div class="level-content">
                  <div>
                    <h6 class="level-title">Level {{ i + 1 }}</h6>
                    <p class="level-description">
                      {{ level.get('name')?.value || level.get('description')?.value || 'No description' }}
                    </p>
                    <span class="level-time" *ngIf="level.get('level_timeline')?.value">
                      {{ calculateTimeFromNow(level.get('level_timeline')?.value) }}
                    </span>
                    <span class="level-time" *ngIf="!level.get('level_timeline')?.value">
                      Timeline not set
                    </span>
                  </div>

                  <button class="btn-play" type="button">Play</button>

                </div>
              </div>
            </div>

            <ng-template #noLevels>
              <p class="text-muted text-center py-3">No levels added yet</p>
            </ng-template>
          </div>
          <!-- -----Location------- -->
          <div class="luqta-review-card">
            <div class="detail">
              <h5>Location</h5>
              <div class="select-options"
                *ngIf="addContentForm.controls['location'].value?.length > 0; else noLocation">
                <a href="javascript:void(0)" class="option"
                  *ngFor="let loc of addContentForm.controls['location'].value | slice:0:2">
                  {{ loc }}
                </a>
                <a href="javascript:void(0)" class="option"
                  *ngIf="addContentForm.controls['location'].value?.length > 2" nz-tooltip
                  [nzTooltipTitle]="remainingLocationsTooltip" nzTooltipPlacement="bottom"
                  [nzTooltipOverlayStyle]="{'max-width': '400px', 'white-space': 'normal'}">
                  + {{ addContentForm.controls['location'].value.length - 2 }} more
                </a>
                <ng-template #remainingLocationsTooltip>
                  <span *ngFor="let loc of addContentForm.controls['location'].value | slice:2; let last = last">{{ loc
                    }}{{ last ? '' : ', ' }}</span>
                </ng-template>
              </div>
              <ng-template #noLocation>
                <p>No Location Selected</p>
              </ng-template>
            </div>
            <div class="detail">
              <h5>Sharing Setting</h5>
              <div class="select-options">
                <a href="javascript:void(0)" class="option">
                  {{ addContentForm.controls['sharingSetting'].value === 'share' ?
                  ('addContests.sharingSetting.share' | translate) :
                  ('addContests.sharingSetting.single' | translate) }}
                </a>
              </div>
            </div>
            <div class="detail">
              <h5>
                Number of Winners
              </h5>
              <p>{{ addContentForm.controls['number_of_winners'].value || 'No winner yet' }}</p>
            </div>
          </div>


        </div>
      </div>
    </form>
  </div>

  <!-- Private Contest Modal -->
  <nz-modal [(nzVisible)]="isAccessCodeModalVisible" [nzFooter]="null" [nzClosable]="false" [nzMaskClosable]="false"
    nzClassName="private-model" [nzCentered]="true">

    <div *nzModalContent>
      <div class="private-contest-modal">


        <div class="close" (click)="handleAccessCodeModalOk()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#E6E6E6" />
            <path d="M15.6023 8.40234L8.40234 15.6023M8.40234 8.40234L15.6023 15.6023" stroke="black"
              stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <img src="../../../../assets/images/key.png" alt="Private Engagement Key">
        <h3>
          Private Engagement
        </h3>
        <p>
          Your private engagement is now live. Share this access code with participants.
        </p>
        <div class="form-group">
          <label for="" class="form-label">Access Key</label>
          <input type="text" id="contestAccessCode" class="form-control" [value]="accessCode || 'N/A'" readonly>
        </div>
        <button type="button" class="btn btn-primary w-100" (click)="copyAccessCode()">
          {{ isCodeCopied ? 'Copied!' : 'Copy Access Key' }}
        </button>
      </div>
    </div>
  </nz-modal>

  <!-- Image Full Preview Modal -->
  <nz-modal
    [(nzVisible)]="isImagePreviewVisible"
    [nzFooter]="null"
    [nzClosable]="true"
    [nzMaskClosable]="true"
    (nzOnCancel)="isImagePreviewVisible = false"
    nzWidth="90vw"
    nzClassName="image-fullpreview-modal">
    <ng-container *nzModalContent>
      <div class="fullpreview-wrap">
        <div class="fullpreview-header">
          <span>{{ imagePreviewTitle }}</span>
        </div>
        <div class="fullpreview-body">
          <img [src]="imagePreviewUrl" [alt]="imagePreviewTitle" />
        </div>
      </div>
    </ng-container>
  </nz-modal>
</div>

  <!-- AI Image Regenerate Modal -->
  <nz-modal
    [(nzVisible)]="isAiRegenModalVisible"
    [nzFooter]="null"
    [nzClosable]="false"
    [nzMaskClosable]="true"
    (nzOnCancel)="isAiRegenModalVisible = false"
    nzWidth="560px"
    nzClassName="ai-regen-modal">
    <ng-container *nzModalContent>
      <div class="ai-regen-wrap" style="border-radius:16px;overflow:hidden;">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;padding:20px 24px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <div style="width:36px;height:36px;border-radius:10px;background:#5304FB;display:flex;align-items:center;justify-content:center;">
              <i class="fa-solid fa-wand-magic-sparkles" style="color:white;font-size:16px;"></i>
            </div>
            <div>
              <h3 style="margin:0;font-size:16px;font-weight:700;color:#1F2937;">
                {{ aiRegenContext === 'prize' ? 'Generate Prize Image with AI' : aiRegenContext === 'level' ? 'Generate Level Image with AI' : 'Regenerate Banner with AI' }}
              </h3>
              <p style="margin:0;font-size:11px;color:#B0B7C3;margin-top:2px;">
                <i class="fa-solid fa-circle-info" style="margin-right:3px;"></i>
                High quality, 8k, photorealistic, no text/watermark will be added automatically
              </p>
            </div>
          </div>
          <button style="background:none;border:none;cursor:pointer;color:#9CA3AF;font-size:18px;padding:4px;margin-top:2px;" (click)="isAiRegenModalVisible = false">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div style="padding:0 24px 20px;">
          <!-- Preview Image -->
          <div *ngIf="aiRegenPreviewUrl" style="margin-bottom:14px;border-radius:12px;overflow:hidden;border:1.5px solid #E2E8F0;">
            <img [src]="aiRegenPreviewUrl" alt="AI Preview" style="width:100%;max-height:250px;object-fit:cover;display:block;" />
          </div>
          <!-- Prompt Textarea -->
          <textarea [(ngModel)]="aiRegenPrompt" rows="4"
            style="width:100%;padding:12px;border:1.5px solid #E2E8F0;border-radius:12px;font-size:13px;font-family:inherit;resize:vertical;outline:none;"
            placeholder="Describe the banner image you want..."></textarea>
        </div>
        <div style="padding:12px 24px 20px;display:flex;justify-content:flex-end;gap:10px;border-top:1px solid #F1F5F9;">
          <button style="padding:8px 20px;border-radius:10px;border:1.5px solid #E2E8F0;background:white;color:#64748B;font-size:14px;cursor:pointer;" (click)="isAiRegenModalVisible = false">Cancel</button>
          <!-- Regenerate button (shown after first generation) -->
          <button *ngIf="aiRegenPreviewUrl"
            style="padding:8px 20px;border-radius:10px;border:1.5px solid #F59E0B;background:#FFFBEB;color:#B45309;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px;"
            [disabled]="aiRegeneratingBanner"
            (click)="submitAiRegen()">
            <i class="fa-solid" [ngClass]="aiRegeneratingBanner ? 'fa-spinner fa-spin' : 'fa-rotate'"></i>
            {{ aiRegeneratingBanner ? 'Regenerating...' : 'Regenerate' }}
          </button>
          <!-- Generate / Use This button -->
          <button style="padding:8px 24px;border-radius:10px;border:none;background:#5304FB;color:white;font-size:14px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:8px;"
            [disabled]="aiRegeneratingBanner || !aiRegenPrompt.trim()"
            [style.opacity]="aiRegeneratingBanner ? '0.7' : '1'"
            (click)="aiRegenPreviewUrl ? applyAiRegenImage() : submitAiRegen()">
            <i class="fa-solid" [ngClass]="aiRegeneratingBanner ? 'fa-spinner fa-spin' : (aiRegenPreviewUrl ? 'fa-check' : 'fa-wand-magic-sparkles')"></i>
            {{ aiRegeneratingBanner ? 'Generating...' : (aiRegenPreviewUrl ? 'Use This' : 'Generate') }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-modal>

<!-- OLD CODE -->
